import { IApplicationState } from '../../types/redux';

export const selectResultsDominantSubdomain = (state: IApplicationState) => {
  return state.results.dominantSubdomain;
};
